export const environment = {
  environment: 'development',
  // Keycloak
  keycloakUrl: 'https://auth.test123.nl',
  keycloakRealm: 'rose-stories',
  keycloakClientId: 'staging',
  // API
  apiUrl: 'https://ros-cms-api.test123.nl'
};
